"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7333],{

/***/ 27333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(50029);
/* harmony import */ var _home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54176);
/* harmony import */ var _DAO__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90793);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(84099);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(48409);
/* harmony import */ var react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(79057);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9465);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_molecules_TagList_components_TagItem__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52755);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31304);
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(slugify__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















var GuideProfile = function GuideProfile(props) {
  var isMobileVersion = props.isMobileVersion,
      categoryType = props.categoryType;
  var _props$item = props.item,
      stateId = _props$item.stateId,
      stateName = _props$item.stateName,
      cityId = _props$item.cityId,
      city = _props$item.city,
      countryId = _props$item.countryId,
      city_id = _props$item.city_id,
      state_id = _props$item.state_id,
      country_id = _props$item.country_id,
      nationality = _props$item.nationality,
      regionName = _props$item.regionName,
      subRegionName = _props$item.subRegionName,
      startDate = _props$item.startDate,
      endDate = _props$item.endDate,
      id = _props$item.id,
      globalId = _props$item.globalId;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]),
      items = _useState[0],
      setItems = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function () {
    onLoad();
  }, [JSON.stringify(props.item)]);

  var getMetaTitle = function getMetaTitle(item, type) {
    var _item$filterName, _item$filterName$repl, _item$filterName2, _item$filterName2$rep, _item$filterName2$rep2, _item$filterName2$rep3, _item$filterName2$rep4, _item$filterName2$rep5, _item$filterName2$rep6, _item$filterName2$rep7, _item$filterName3, _item$filterName3$rep;

    var location = type === "world" ? "World" : type === "city" ? city : type === "state" ? stateName : type === "country" ? nationality : "";
    var result = "".concat((categoryType === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ZOO */ .gT.categoryType.CATEGORY_ZOO || categoryType === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PARKFUL */ .gT.categoryType.CATEGORY_PARKFUL) && (item === null || item === void 0 ? void 0 : item.filterName) !== "All" ? (item === null || item === void 0 ? void 0 : item.filterName) !== "All" && (item === null || item === void 0 ? void 0 : item.filterName) !== "Aviary" && (item === null || item === void 0 ? void 0 : item.filterName) !== "Animal sanctuary" && (item === null || item === void 0 ? void 0 : item.filterName) !== "Basic" && (item === null || item === void 0 ? void 0 : item.filterName) !== "Premium" && (item === null || item === void 0 ? void 0 : item.filterName) !== "Luxury" && (item === null || item === void 0 ? void 0 : item.filterName) !== "Best" ? (item === null || item === void 0 ? void 0 : item.filterName) + "s " : (item === null || item === void 0 ? void 0 : (_item$filterName = item.filterName) === null || _item$filterName === void 0 ? void 0 : (_item$filterName$repl = _item$filterName.replace("Aviary", "Aviaries")) === null || _item$filterName$repl === void 0 ? void 0 : _item$filterName$repl.replace("Animal sanctuary", "Animal sanctuaries")) + " " : (item === null || item === void 0 ? void 0 : item.filterName) !== "Pool" && (item === null || item === void 0 ? void 0 : item.filterName) !== "Bar" && (item === null || item === void 0 ? void 0 : item.filterName) !== "Restaurant" ? (item === null || item === void 0 ? void 0 : (_item$filterName2 = item.filterName) === null || _item$filterName2 === void 0 ? void 0 : (_item$filterName2$rep = _item$filterName2.replace("All", "")) === null || _item$filterName2$rep === void 0 ? void 0 : (_item$filterName2$rep2 = _item$filterName2$rep.replace("Day Spa", "Day")) === null || _item$filterName2$rep2 === void 0 ? void 0 : (_item$filterName2$rep3 = _item$filterName2$rep2.replace("Destination Spa", "Destination")) === null || _item$filterName2$rep3 === void 0 ? void 0 : (_item$filterName2$rep4 = _item$filterName2$rep3.replace("Thermal Spa", "Thermal")) === null || _item$filterName2$rep4 === void 0 ? void 0 : (_item$filterName2$rep5 = _item$filterName2$rep4.replace("Hotel Spa", "Hotel")) === null || _item$filterName2$rep5 === void 0 ? void 0 : (_item$filterName2$rep6 = _item$filterName2$rep5.replace("Club Spa", "Club")) === null || _item$filterName2$rep6 === void 0 ? void 0 : (_item$filterName2$rep7 = _item$filterName2$rep6.replace("Medical Spa", "Medical")) === null || _item$filterName2$rep7 === void 0 ? void 0 : _item$filterName2$rep7.toLowerCase()) + " " : "").concat( false ? 0 :  false ? 0 :  true ? "cocktail bars" : 0).concat((item === null || item === void 0 ? void 0 : item.filterName) === "Pool" || (item === null || item === void 0 ? void 0 : item.filterName) === "Bar" || (item === null || item === void 0 ? void 0 : item.filterName) === "Restaurant" ? " " + (item === null || item === void 0 ? void 0 : (_item$filterName3 = item.filterName) === null || _item$filterName3 === void 0 ? void 0 : (_item$filterName3$rep = _item$filterName3.replace("All", "")) === null || _item$filterName3$rep === void 0 ? void 0 : _item$filterName3$rep.toLowerCase()) + "s " : " ").concat(location || "World");
    return (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .capitalizeFirstLetter */ .fm)(result === null || result === void 0 ? void 0 : result.trim());
  };

  var getMetaLink = function getMetaLink(item, type) {
    var _subRegionName$replac, _item$filterName4, _item$filterName5, _item$filterName5$rep, _item$filterName5$rep2, _item$filterName6, _item$filterName6$rep, _item$filterName7;

    var continent = type === "world" ? "World" : regionName === "Americas" ? subRegionName !== "South America" && subRegionName !== "Northern America" ? "South America" : subRegionName === null || subRegionName === void 0 ? void 0 : (_subRegionName$replac = subRegionName.replace("Northern", "North")) === null || _subRegionName$replac === void 0 ? void 0 : _subRegionName$replac.toLowerCase() : regionName === null || regionName === void 0 ? void 0 : regionName.toLowerCase();
    var prefixURL = type === "city" ? "/guides/".concat( false ? 0 : "").concat(slugify__WEBPACK_IMPORTED_MODULE_9___default()(continent === null || continent === void 0 ? void 0 : continent.toLowerCase()), "/").concat(slugify__WEBPACK_IMPORTED_MODULE_9___default()(nationality === null || nationality === void 0 ? void 0 : nationality.toLowerCase()), "/").concat(slugify__WEBPACK_IMPORTED_MODULE_9___default()(city === null || city === void 0 ? void 0 : city.toLowerCase())).concat( false ? 0 : "") : type === "state" ? "/guides/".concat( false ? 0 : "").concat( false ? 0 : "".concat(slugify__WEBPACK_IMPORTED_MODULE_9___default()(continent === null || continent === void 0 ? void 0 : continent.toLowerCase()), "/")).concat(slugify__WEBPACK_IMPORTED_MODULE_9___default()(nationality === null || nationality === void 0 ? void 0 : nationality.toLowerCase()), "/").concat(slugify__WEBPACK_IMPORTED_MODULE_9___default()(stateName === null || stateName === void 0 ? void 0 : stateName.toLowerCase())).concat( false ? 0 : "") : type === "country" ? "/guides/".concat( false ? 0 : "").concat( false ? 0 : "".concat(slugify__WEBPACK_IMPORTED_MODULE_9___default()(continent === null || continent === void 0 ? void 0 : continent.toLowerCase()), "/")).concat(slugify__WEBPACK_IMPORTED_MODULE_9___default()(nationality === null || nationality === void 0 ? void 0 : nationality.toLowerCase())) : type === "world" ? "/guides/world/" : "";
    var filterName = "".concat((item === null || item === void 0 ? void 0 : item.filterName) === "All" ?  false ? 0 :  false ? 0 :  true ? "cocktail-bars" : 0 : ( false ? 0 : (item === null || item === void 0 ? void 0 : item.filterName) !== "Pool" && (item === null || item === void 0 ? void 0 : item.filterName) !== "Bar" && (item === null || item === void 0 ? void 0 : item.filterName) !== "Restaurant" ? slugify__WEBPACK_IMPORTED_MODULE_9___default()(item === null || item === void 0 ? void 0 : (_item$filterName6 = item.filterName) === null || _item$filterName6 === void 0 ? void 0 : (_item$filterName6$rep = _item$filterName6.replace(" Spa", "")) === null || _item$filterName6$rep === void 0 ? void 0 : _item$filterName6$rep.toLowerCase()) + "-" : "") + "".concat( false ? 0 :  false ? 0 :  true ? "cocktail-bars" : 0).concat(item && ((item === null || item === void 0 ? void 0 : item.filterName) === "Pool" || (item === null || item === void 0 ? void 0 : item.filterName) === "Bar" || (item === null || item === void 0 ? void 0 : item.filterName) === "Restaurant") ? "-" + slugify__WEBPACK_IMPORTED_MODULE_9___default()((item === null || item === void 0 ? void 0 : (_item$filterName7 = item.filterName) === null || _item$filterName7 === void 0 ? void 0 : _item$filterName7.toLowerCase()) + "s") : ""));
    return "".concat(prefixURL, "/").concat( false ? 0 : filterName);
  };

  var onLoad = function onLoad() {
    if (isLoading) return;
    setIsLoading(true);
    var results = [];

    if (false) {} else {
      onLoadSecond(results);
    }
  };

  var onLoadSecond = function onLoadSecond(results) {
    _DAO__WEBPACK_IMPORTED_MODULE_3__/* .LocationDao.findProgmatic */ .c0.findProgmatic({
      categoryType: categoryType,
      progFilterType: "filter",
      countryId:  false ? 0 : countryId,
      year:  false ? 0 : null
    }).then( /*#__PURE__*/function () {
      var _ref3 = (0,_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee12(resultCountry) {
        return _home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (!(nationality && resultCountry.find(function (i) {
                  return i.countryId == countryId;
                }) && ( false || "Cocktayl" == "Beachful"))) {
                  _context12.next = 8;
                  break;
                }

                _context12.t0 = results;
                _context12.next = 4;
                return Promise.all((0,lodash__WEBPACK_IMPORTED_MODULE_10__.uniqBy)(resultCountry, "filterId").map( /*#__PURE__*/function () {
                  var _ref4 = (0,_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(item) {
                    var _yield$Promise2, listDataResult, countListDataResult;

                    return _home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return new Promise(function (resolve, reject) {
                              _DAO__WEBPACK_IMPORTED_MODULE_3__/* .VenueDao.find */ .eL.find({
                                categoryType: categoryType,
                                pageIndex: 0,
                                pageSize: 1,
                                venueStatus: [_config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.venueStatus.FE_STAT_OPEN */ .gT.venueStatus.FE_STAT_OPEN, _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.venueStatus.FE_STAT_CLOSE */ .gT.venueStatus.FE_STAT_CLOSE, _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.venueStatus.FE_STAT_TEMPORARILY_CLOSED */ .gT.venueStatus.FE_STAT_TEMPORARILY_CLOSED],
                                sortType: _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.sortByAction.SORT_BY_RECOMMENDED */ .gT.sortByAction.SORT_BY_RECOMMENDED,
                                progFilterId: item.filterId,
                                countryId: [countryId],
                                globalId: globalId
                              }).then(function (result) {
                                return resolve({
                                  listDataResult: result.data,
                                  countListDataResult: result.totalCount
                                });
                              })["catch"](function (err) {
                                return reject(err);
                              });
                            });

                          case 2:
                            _yield$Promise2 = _context3.sent;
                            listDataResult = _yield$Promise2.listDataResult;
                            countListDataResult = _yield$Promise2.countListDataResult;

                            if (!listDataResult.find(function (i) {
                              return i.id === id;
                            })) {
                              _context3.next = 7;
                              break;
                            }

                            return _context3.abrupt("return", _objectSpread(_objectSpread({}, item), {}, {
                              metaTitle: getMetaTitle(item, "country"),
                              metaLink: getMetaLink(item, "country"),
                              type: "country"
                            }));

                          case 7:
                            return _context3.abrupt("return", null);

                          case 8:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x4) {
                    return _ref4.apply(this, arguments);
                  };
                }()).filter(function (i) {
                  return i;
                }));

              case 4:
                _context12.t1 = _context12.sent;
                results = _context12.t0.concat.call(_context12.t0, _context12.t1);
                _context12.next = 22;
                break;

              case 8:
                if (!(nationality && resultCountry.find(function (i) {
                  return i.countryId == country_id;
                }) && "Cocktayl" == "Festyful")) {
                  _context12.next = 16;
                  break;
                }

                _context12.t2 = results;
                _context12.next = 12;
                return Promise.all((0,lodash__WEBPACK_IMPORTED_MODULE_10__.uniqBy)(resultCountry, "filterId").map( /*#__PURE__*/function () {
                  var _ref5 = (0,_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4(item) {
                    var _yield$Promise3, listDataResult, countListDataResult;

                    return _home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            _context4.next = 2;
                            return new Promise(function (resolve, reject) {
                              _DAO__WEBPACK_IMPORTED_MODULE_3__/* .FestivalDao.findWeb */ .vB.findWeb({
                                categoryType: categoryType,
                                pageIndex: 0,
                                pageSize: 1,
                                sortType: _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.sortByAction.SORT_BY_RECENT */ .gT.sortByAction.SORT_BY_RECENT,
                                startDateFrom: moment__WEBPACK_IMPORTED_MODULE_8___default()(startDate).startOf("year").format("YYYY-MM-DD"),
                                startDateTo: moment__WEBPACK_IMPORTED_MODULE_8___default()(startDate).endOf("year").format("YYYY-MM-DD"),
                                progFilterId: item.filterId,
                                countryId: [country_id],
                                globalId: globalId
                              }).then(function (result) {
                                return resolve({
                                  listDataResult: result.data,
                                  countListDataResult: result.totalCount
                                });
                              })["catch"](function (err) {
                                return reject(err);
                              });
                            });

                          case 2:
                            _yield$Promise3 = _context4.sent;
                            listDataResult = _yield$Promise3.listDataResult;
                            countListDataResult = _yield$Promise3.countListDataResult;

                            if (!listDataResult.find(function (i) {
                              return i.id === id;
                            })) {
                              _context4.next = 7;
                              break;
                            }

                            return _context4.abrupt("return", _objectSpread(_objectSpread({}, item), {}, {
                              metaTitle: getMetaTitle(item, "country"),
                              metaLink: getMetaLink(item, "country"),
                              type: "country"
                            }));

                          case 7:
                            return _context4.abrupt("return", null);

                          case 8:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  }));

                  return function (_x5) {
                    return _ref5.apply(this, arguments);
                  };
                }()).filter(function (i) {
                  return i;
                }));

              case 12:
                _context12.t3 = _context12.sent;
                results = _context12.t2.concat.call(_context12.t2, _context12.t3);
                _context12.next = 22;
                break;

              case 16:
                if (!(nationality && resultCountry.find(function (i) {
                  return i.countryId == countryId;
                }) && ( false || "Cocktayl" == "AparthotelClub"))) {
                  _context12.next = 22;
                  break;
                }

                _context12.t4 = results;
                _context12.next = 20;
                return Promise.all((0,lodash__WEBPACK_IMPORTED_MODULE_10__.uniqBy)(resultCountry, "filterId").map( /*#__PURE__*/function () {
                  var _ref6 = (0,_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5(item) {
                    var _yield$Promise4, listDataResult, countListDataResult;

                    return _home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            _context5.next = 2;
                            return new Promise(function (resolve, reject) {
                              _DAO__WEBPACK_IMPORTED_MODULE_3__/* .VenueDao.find */ .eL.find({
                                categoryType: categoryType,
                                pageIndex: 0,
                                pageSize: 1,
                                sortType: _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.sortByAction.SORT_BY_RECOMMENDED */ .gT.sortByAction.SORT_BY_RECOMMENDED,
                                progFilterId: item.filterId,
                                countryId: [countryId],
                                globalId: globalId
                              }).then(function (result) {
                                return resolve({
                                  listDataResult: result.data,
                                  countListDataResult: result.totalCount
                                });
                              })["catch"](function (err) {
                                return reject(err);
                              });
                            });

                          case 2:
                            _yield$Promise4 = _context5.sent;
                            listDataResult = _yield$Promise4.listDataResult;
                            countListDataResult = _yield$Promise4.countListDataResult;

                            if (!listDataResult.find(function (i) {
                              return i.id === id;
                            })) {
                              _context5.next = 7;
                              break;
                            }

                            return _context5.abrupt("return", _objectSpread(_objectSpread({}, item), {}, {
                              metaTitle: getMetaTitle(item, "country"),
                              metaLink: getMetaLink(item, "country"),
                              type: "country"
                            }));

                          case 7:
                            return _context5.abrupt("return", null);

                          case 8:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5);
                  }));

                  return function (_x6) {
                    return _ref6.apply(this, arguments);
                  };
                }()).filter(function (i) {
                  return i;
                }));

              case 20:
                _context12.t5 = _context12.sent;
                results = _context12.t4.concat.call(_context12.t4, _context12.t5);

              case 22:
                _DAO__WEBPACK_IMPORTED_MODULE_3__/* .LocationDao.findProgmatic */ .c0.findProgmatic({
                  categoryType: categoryType,
                  progFilterType:  false ? 0 : "filter",
                  countryId:  false ? 0 : countryId,
                  stateId:  false ? 0 : stateId,
                  year:  false ? 0 : null
                }).then( /*#__PURE__*/function () {
                  var _ref7 = (0,_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee11(resultState) {
                    return _home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee11$(_context11) {
                      while (1) {
                        switch (_context11.prev = _context11.next) {
                          case 0:
                            if (!(stateName && resultState.find(function (i) {
                              return i.stateId == stateId;
                            }) && ( false || "Cocktayl" == "Beachful"))) {
                              _context11.next = 8;
                              break;
                            }

                            _context11.t0 = results;
                            _context11.next = 4;
                            return Promise.all((0,lodash__WEBPACK_IMPORTED_MODULE_10__.uniqBy)(resultState, "filterId").map( /*#__PURE__*/function () {
                              var _ref8 = (0,_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee6(item) {
                                var _yield$Promise5, listDataResult, countListDataResult;

                                return _home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee6$(_context6) {
                                  while (1) {
                                    switch (_context6.prev = _context6.next) {
                                      case 0:
                                        _context6.next = 2;
                                        return new Promise(function (resolve, reject) {
                                          _DAO__WEBPACK_IMPORTED_MODULE_3__/* .VenueDao.find */ .eL.find({
                                            categoryType: categoryType,
                                            pageIndex: 0,
                                            pageSize: 1,
                                            venueStatus: [_config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.venueStatus.FE_STAT_OPEN */ .gT.venueStatus.FE_STAT_OPEN, _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.venueStatus.FE_STAT_CLOSE */ .gT.venueStatus.FE_STAT_CLOSE, _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.venueStatus.FE_STAT_TEMPORARILY_CLOSED */ .gT.venueStatus.FE_STAT_TEMPORARILY_CLOSED],
                                            sortType: _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.sortByAction.SORT_BY_RECOMMENDED */ .gT.sortByAction.SORT_BY_RECOMMENDED,
                                            progFilterId: item.filterId,
                                            countryId: [countryId],
                                            stateId: stateId,
                                            globalId: globalId
                                          }).then(function (result) {
                                            return resolve({
                                              listDataResult: result.data,
                                              countListDataResult: result.totalCount
                                            });
                                          })["catch"](function (err) {
                                            return reject(err);
                                          });
                                        });

                                      case 2:
                                        _yield$Promise5 = _context6.sent;
                                        listDataResult = _yield$Promise5.listDataResult;
                                        countListDataResult = _yield$Promise5.countListDataResult;

                                        if (!listDataResult.find(function (i) {
                                          return i.id === id;
                                        })) {
                                          _context6.next = 7;
                                          break;
                                        }

                                        return _context6.abrupt("return", _objectSpread(_objectSpread({}, item), {}, {
                                          metaTitle: getMetaTitle(item, "state"),
                                          metaLink: getMetaLink(item, "state"),
                                          type: "state"
                                        }));

                                      case 7:
                                        return _context6.abrupt("return", null);

                                      case 8:
                                      case "end":
                                        return _context6.stop();
                                    }
                                  }
                                }, _callee6);
                              }));

                              return function (_x8) {
                                return _ref8.apply(this, arguments);
                              };
                            }()));

                          case 4:
                            _context11.t1 = _context11.sent;
                            results = _context11.t0.concat.call(_context11.t0, _context11.t1);
                            _context11.next = 22;
                            break;

                          case 8:
                            if (!(stateName && resultState.find(function (i) {
                              return i.stateId == state_id;
                            }) && "Cocktayl" == "Festyful")) {
                              _context11.next = 16;
                              break;
                            }

                            _context11.t2 = results;
                            _context11.next = 12;
                            return Promise.all((0,lodash__WEBPACK_IMPORTED_MODULE_10__.uniqBy)(resultState, "filterId").map( /*#__PURE__*/function () {
                              var _ref9 = (0,_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee7(item) {
                                var _yield$Promise6, listDataResult, countListDataResult;

                                return _home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee7$(_context7) {
                                  while (1) {
                                    switch (_context7.prev = _context7.next) {
                                      case 0:
                                        _context7.next = 2;
                                        return new Promise(function (resolve, reject) {
                                          _DAO__WEBPACK_IMPORTED_MODULE_3__/* .FestivalDao.findWeb */ .vB.findWeb({
                                            categoryType: categoryType,
                                            pageIndex: 0,
                                            pageSize: 1,
                                            sortType: _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.sortByAction.SORT_BY_RECENT */ .gT.sortByAction.SORT_BY_RECENT,
                                            startDateFrom: moment__WEBPACK_IMPORTED_MODULE_8___default()(startDate).startOf("year").format("YYYY-MM-DD"),
                                            startDateTo: moment__WEBPACK_IMPORTED_MODULE_8___default()(startDate).endOf("year").format("YYYY-MM-DD"),
                                            progFilterId: item.filterId,
                                            stateId: state_id,
                                            countryId: [country_id],
                                            globalId: globalId
                                          }).then(function (result) {
                                            return resolve({
                                              listDataResult: result.data,
                                              countListDataResult: result.totalCount
                                            });
                                          })["catch"](function (err) {
                                            return reject(err);
                                          });
                                        });

                                      case 2:
                                        _yield$Promise6 = _context7.sent;
                                        listDataResult = _yield$Promise6.listDataResult;
                                        countListDataResult = _yield$Promise6.countListDataResult;

                                        if (!listDataResult.find(function (i) {
                                          return i.id === id;
                                        })) {
                                          _context7.next = 7;
                                          break;
                                        }

                                        return _context7.abrupt("return", _objectSpread(_objectSpread({}, item), {}, {
                                          metaTitle: getMetaTitle(item, "state"),
                                          metaLink: getMetaLink(item, "state"),
                                          type: "state"
                                        }));

                                      case 7:
                                        return _context7.abrupt("return", null);

                                      case 8:
                                      case "end":
                                        return _context7.stop();
                                    }
                                  }
                                }, _callee7);
                              }));

                              return function (_x9) {
                                return _ref9.apply(this, arguments);
                              };
                            }()));

                          case 12:
                            _context11.t3 = _context11.sent;
                            results = _context11.t2.concat.call(_context11.t2, _context11.t3);
                            _context11.next = 22;
                            break;

                          case 16:
                            if (!(stateName && resultState.find(function (i) {
                              return i.stateId == stateId;
                            }) && ( false || "Cocktayl" == "AparthotelClub"))) {
                              _context11.next = 22;
                              break;
                            }

                            _context11.t4 = results;
                            _context11.next = 20;
                            return Promise.all((0,lodash__WEBPACK_IMPORTED_MODULE_10__.uniqBy)(resultState, "filterId").map( /*#__PURE__*/function () {
                              var _ref10 = (0,_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee8(item) {
                                var _yield$Promise7, listDataResult, countListDataResult;

                                return _home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee8$(_context8) {
                                  while (1) {
                                    switch (_context8.prev = _context8.next) {
                                      case 0:
                                        _context8.next = 2;
                                        return new Promise(function (resolve, reject) {
                                          _DAO__WEBPACK_IMPORTED_MODULE_3__/* .VenueDao.find */ .eL.find({
                                            categoryType: categoryType,
                                            pageIndex: 0,
                                            pageSize: 1,
                                            sortType: _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.sortByAction.SORT_BY_RECOMMENDED */ .gT.sortByAction.SORT_BY_RECOMMENDED,
                                            progFilterId: item.filterId,
                                            countryId: [countryId],
                                            stateId: stateId,
                                            globalId: globalId
                                          }).then(function (result) {
                                            return resolve({
                                              listDataResult: result.data,
                                              countListDataResult: result.totalCount
                                            });
                                          })["catch"](function (err) {
                                            return reject(err);
                                          });
                                        });

                                      case 2:
                                        _yield$Promise7 = _context8.sent;
                                        listDataResult = _yield$Promise7.listDataResult;
                                        countListDataResult = _yield$Promise7.countListDataResult;

                                        if (!listDataResult.find(function (i) {
                                          return i.id === id;
                                        })) {
                                          _context8.next = 7;
                                          break;
                                        }

                                        return _context8.abrupt("return", _objectSpread(_objectSpread({}, item), {}, {
                                          metaTitle: getMetaTitle(item, "state"),
                                          metaLink: getMetaLink(item, "state"),
                                          type: "state"
                                        }));

                                      case 7:
                                        return _context8.abrupt("return", null);

                                      case 8:
                                      case "end":
                                        return _context8.stop();
                                    }
                                  }
                                }, _callee8);
                              }));

                              return function (_x10) {
                                return _ref10.apply(this, arguments);
                              };
                            }()));

                          case 20:
                            _context11.t5 = _context11.sent;
                            results = _context11.t4.concat.call(_context11.t4, _context11.t5);

                          case 22:
                            _DAO__WEBPACK_IMPORTED_MODULE_3__/* .LocationDao.findProgmatic */ .c0.findProgmatic({
                              categoryType: categoryType,
                              progFilterType:  false ? 0 : "filter",
                              countryId:  false ? 0 : countryId,
                              stateId:  false ? 0 : stateId,
                              cityId:  false ? 0 : cityId,
                              year:  false ? 0 : null
                            }).then( /*#__PURE__*/function () {
                              var _ref11 = (0,_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee10(resultCity) {
                                return _home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee10$(_context10) {
                                  while (1) {
                                    switch (_context10.prev = _context10.next) {
                                      case 0:
                                        if (!(city && "Cocktayl" !== "PrefabWorld" && resultCity.find(function (i) {
                                          return i.cityId == ( false ? 0 : cityId);
                                        }))) {
                                          _context10.next = 6;
                                          break;
                                        }

                                        _context10.t0 = results;
                                        _context10.next = 4;
                                        return Promise.all((0,lodash__WEBPACK_IMPORTED_MODULE_10__.uniqBy)(resultCity, "filterId").map( /*#__PURE__*/function () {
                                          var _ref12 = (0,_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee9(item) {
                                            var _yield$Promise8, listDataResult, countListDataResult, _yield$Promise9, _listDataResult, _countListDataResult;

                                            return _home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee9$(_context9) {
                                              while (1) {
                                                switch (_context9.prev = _context9.next) {
                                                  case 0:
                                                    if (true) {
                                                      _context9.next = 10;
                                                      break;
                                                    }

                                                    _context9.next = 3;
                                                    return new Promise(function (resolve, reject) {
                                                      _DAO__WEBPACK_IMPORTED_MODULE_3__/* .FestivalDao.findWeb */ .vB.findWeb({
                                                        categoryType: categoryType,
                                                        pageIndex: 0,
                                                        pageSize: 1,
                                                        sortType: _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.sortByAction.SORT_BY_RECENT */ .gT.sortByAction.SORT_BY_RECENT,
                                                        startDateFrom: moment__WEBPACK_IMPORTED_MODULE_8___default()(startDate).startOf("year").format("YYYY-MM-DD"),
                                                        startDateTo: moment__WEBPACK_IMPORTED_MODULE_8___default()(startDate).endOf("year").format("YYYY-MM-DD"),
                                                        progFilterId: item.filterId,
                                                        cityId: city_id,
                                                        stateId: state_id,
                                                        countryId: [country_id],
                                                        globalId: globalId
                                                      }).then(function (result) {
                                                        return resolve({
                                                          listDataResult: result.data,
                                                          countListDataResult: result.totalCount
                                                        });
                                                      })["catch"](function (err) {
                                                        return reject(err);
                                                      });
                                                    });

                                                  case 3:
                                                    _yield$Promise8 = _context9.sent;
                                                    listDataResult = _yield$Promise8.listDataResult;
                                                    countListDataResult = _yield$Promise8.countListDataResult;

                                                    if (!listDataResult.find(function (i) {
                                                      return i.id === id;
                                                    })) {
                                                      _context9.next = 8;
                                                      break;
                                                    }

                                                    return _context9.abrupt("return", _objectSpread(_objectSpread({}, item), {}, {
                                                      metaTitle: getMetaTitle(item, "city"),
                                                      metaLink: getMetaLink(item, "city"),
                                                      type: "city"
                                                    }));

                                                  case 8:
                                                    _context9.next = 17;
                                                    break;

                                                  case 10:
                                                    _context9.next = 12;
                                                    return new Promise(function (resolve, reject) {
                                                      _DAO__WEBPACK_IMPORTED_MODULE_3__/* .VenueDao.find */ .eL.find({
                                                        categoryType: categoryType,
                                                        pageIndex: 0,
                                                        pageSize: 1,
                                                        venueStatus: [_config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.venueStatus.FE_STAT_OPEN */ .gT.venueStatus.FE_STAT_OPEN, _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.venueStatus.FE_STAT_CLOSE */ .gT.venueStatus.FE_STAT_CLOSE, _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.venueStatus.FE_STAT_TEMPORARILY_CLOSED */ .gT.venueStatus.FE_STAT_TEMPORARILY_CLOSED],
                                                        sortType: _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.sortByAction.SORT_BY_RECOMMENDED */ .gT.sortByAction.SORT_BY_RECOMMENDED,
                                                        progFilterId: item.filterId,
                                                        countryId: [countryId],
                                                        stateId: stateId,
                                                        cityId: cityId,
                                                        globalId: globalId
                                                      }).then(function (result) {
                                                        return resolve({
                                                          listDataResult: result.data,
                                                          countListDataResult: result.totalCount
                                                        });
                                                      })["catch"](function (err) {
                                                        return reject(err);
                                                      });
                                                    });

                                                  case 12:
                                                    _yield$Promise9 = _context9.sent;
                                                    _listDataResult = _yield$Promise9.listDataResult;
                                                    _countListDataResult = _yield$Promise9.countListDataResult;

                                                    if (!_listDataResult.find(function (i) {
                                                      return i.id === id;
                                                    })) {
                                                      _context9.next = 17;
                                                      break;
                                                    }

                                                    return _context9.abrupt("return", _objectSpread(_objectSpread({}, item), {}, {
                                                      metaTitle: getMetaTitle(item, "city"),
                                                      metaLink: getMetaLink(item, "city"),
                                                      type: "city"
                                                    }));

                                                  case 17:
                                                    return _context9.abrupt("return", null);

                                                  case 18:
                                                  case "end":
                                                    return _context9.stop();
                                                }
                                              }
                                            }, _callee9);
                                          }));

                                          return function (_x12) {
                                            return _ref12.apply(this, arguments);
                                          };
                                        }()).filter(function (i) {
                                          return i;
                                        }));

                                      case 4:
                                        _context10.t1 = _context10.sent;
                                        results = _context10.t0.concat.call(_context10.t0, _context10.t1);

                                      case 6:
                                        setItems(results.filter(function (i) {
                                          return i && i.metaLink;
                                        }));

                                      case 7:
                                      case "end":
                                        return _context10.stop();
                                    }
                                  }
                                }, _callee10);
                              }));

                              return function (_x11) {
                                return _ref11.apply(this, arguments);
                              };
                            }());

                          case 23:
                          case "end":
                            return _context11.stop();
                        }
                      }
                    }, _callee11);
                  }));

                  return function (_x7) {
                    return _ref7.apply(this, arguments);
                  };
                }());

              case 23:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }());
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_13___default()), {
    style: [styles.container, props.style],
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
      className: isMobileVersion ? "px-4" : "",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_13___default()), {
        style: [styles.itemContainer, isMobileVersion ? {
          height: 32,
          width: 120,
          marginTop: 30
        } : {}],
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_14___default()), {
          style: [styles.title, isMobileVersion ? {
            fontSize: 12,
            lineHeight: 12
          } : {}],
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("h2", {
            children: "Guides"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_14___default()), {
          style: [styles.description, isMobileVersion ? {
            fontSize: 12,
            lineHeight: 12
          } : {}],
          children: items.filter(function (item) {
            return  false ? 0 : item;
          }).filter(function (item) {
            return  false ? 0 : item;
          }).length
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_13___default()), {
        style: {
          flexWrap: "wrap",
          flexDirection: "row",
          paddingRight: 20,
          marginTop: 30,
          paddingHorizontal: 16
        },
        children: items.filter(function (item) {
          return  false ? 0 : item;
        }).filter(function (item) {
          return  false ? 0 : item;
        }).filter(function (item) {
          return item;
        }).map(function (item) {
          var _item$metaTitle;

          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
            href: item.metaLink,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("a", {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components_molecules_TagList_components_TagItem__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                item: {
                  title: (_item$metaTitle = item.metaTitle) === null || _item$metaTitle === void 0 ? void 0 : _item$metaTitle.replace("R&b", "R&B")
                },
                onPressItem: null,
                isMobileVersion: isMobileVersion
              })
            })
          });
        })
      })]
    })
  });
};

var styles = react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_15___default().create({
  itemContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 25,
    marginLeft: 16,
    marginBottom: 30,
    height: 50,
    width: 200,
    backgroundColor: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .getClass */ .ll)("bg-gray1")
  },
  container: {
    alignSelf: "stretch"
  },
  title: {
    color: "white",
    fontSize: 18,
    lineHeight: 30,
    fontWeight: "700",
    fontFamily: _config__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.primaryBold */ .F3.primaryBold
  },
  description: {
    color: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .getClass */ .ll)("text-gray2"),
    fontSize: 18,
    lineHeight: 30,
    fontWeight: "700",
    marginLeft: 8,
    fontFamily: _config__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.primaryBold */ .F3.primaryBold
  },
  loadMoreButtonContainer: {
    width: 180,
    height: 40,
    borderWidth: 1,
    borderColor: _config__WEBPACK_IMPORTED_MODULE_2__/* .Colors.spliterLine */ .wL.spliterLine,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 20,
    alignSelf: "center",
    marginTop: 18
  },
  mobileLoadMoreButtonContainer: {
    width: 120,
    height: 32,
    borderWidth: 1,
    borderColor: _config__WEBPACK_IMPORTED_MODULE_2__/* .Colors.spliterLine */ .wL.spliterLine,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 20,
    alignSelf: "center",
    marginTop: 18
  },
  buttonText: {
    color: _config__WEBPACK_IMPORTED_MODULE_2__/* .Colors.white */ .wL.white,
    fontFamily: _config__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.primaryBold */ .F3.primaryBold,
    fontSize: 16,
    textAlign: "center"
  }
});
/* harmony default export */ __webpack_exports__["default"] = (GuideProfile);

/***/ })

}]);